<template>
  <Confirm
    :value="value"
    v-on="$listeners"
    title="Delete repository"
    :confirmBtn="{ text: 'Yes, delete' }"
  >
    <p>
      This action will delete <i>{{ source.name }}</i> from this website.
    </p>

    <p>
      This means that you won't be able to control the packages that exists in
      this repository any more.
    </p>

    <p>
      Including:
    </p>
    <ul>
      <li v-show="!source.external">
        API keys
      </li>
      <li v-show="!source.external">
        Shared API keys
      </li>
      <li v-show="!source.external">
        Not be able to add this repository again
      </li>
      <li>Package history related to this repository</li>
    </ul>

    <p>Not including:</p>
    <ul>
      <li>Changes on the computer - current packages remains</li>
      <li>
        Changes in your repository - this action does not modify the actual
        repository
      </li>
    </ul>
  </Confirm>
</template>

<script>
export default {
  components: { Confirm: () => import("@/components/main/Confirm.vue") },
  props: { source: Object, value: Boolean }
};
</script>
